/* lib para estilizacao server-side & com sass */
import styled, { css } from "styled-components";

/* componentes que serão estilizados e exportados */
import _AppBar from "@material-ui/core/AppBar";
import _Toolbar from "@material-ui/core/Toolbar";
import _Typography from "@material-ui/core/Typography";

export const Toolbar = styled(_Toolbar)``;
export const Typography = styled(_Typography)``;

export const AppBar = styled(_AppBar)`
  background-color: ${(props) => props.theme.palette[props.bgcolor]} !important;

  ${(props) =>
    props.fixed === "false" &&
    css`
      position: relative !important;
    `};

  .MuiToolbar-root {
    .MuiTypography-root {
      color: ${(props) => props.theme.palette[props.textcolor]} !important;
      font-family: ${(props) => props.theme.fonts.montserrat}, sans-serif;
      font-weight: bolder;
      font-size: 14px !important;
    }
  }
`;
